import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from "react-router-dom";
import 'moment/locale/ar';
import { applyMomentLocale } from './helpers/locale';
import { DEFAULT_LANGUAGE } from './constants/locales';

// Loading a moment locale file also switches moment's global locale to it, so reset to the default.
applyMomentLocale(DEFAULT_LANGUAGE);

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
